import React from 'react'
import { cn, typographyVariants } from './utils'

export interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'lead' | 'large' | 'small' | 'muted' | 'code'
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div' | 'code'
}

const Typography = React.forwardRef<HTMLElement, TypographyProps>(
  ({ className, variant = 'p', as, ...props }, ref) => {
    const Component = as || (variant === 'code' ? 'code' : variant === 'lead' || variant === 'large' || variant === 'small' || variant === 'muted' ? 'p' : variant)
    
    return React.createElement(Component, {
      ref,
      className: cn(typographyVariants.variant[variant], className),
      ...props
    })
  }
)

Typography.displayName = 'Typography'

export { Typography }
